// High enough to hold every filter option (offers, sales managers) in a single page: the largest
// insurer has 19 contract distributions and 3 managers, so paginating the options would be disproportionate.
export const FILTER_OPTIONS_PER_PAGE = 2000;
